"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var checkHasHeaderCell = function (columnKeys) { return !!(columnKeys.headerLabel || columnKeys.headerComponent); };
var checkHasSubheaderCell = function (columnKeys) { return !!(columnKeys.subheaderLabel || columnKeys.subheaderComponent); };
var useGetFixedRowCount = function (columns) {
    var fixedRowCount = (0, react_1.useMemo)(function () {
        var columnKeys = columns.reduce(function (acc, column) { return (__assign(__assign({}, acc), column)); }, {});
        return Number(checkHasHeaderCell(columnKeys)) + Number(checkHasSubheaderCell(columnKeys));
    }, [columns]);
    return fixedRowCount;
};
exports.default = useGetFixedRowCount;
